import React from "react";
import { CalendarFold } from "lucide-react";

const UpcomingFixtures = ({ fixtures, userTeamId }) => {
  const formatDateUTC = (dateStr) => {
    if (!dateStr) return "Invalid date";
    const date = new Date(dateStr);
    if (isNaN(date.getTime())) return "Invalid date";

    return date.toLocaleDateString(undefined, {
      timeZone: "UTC",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "fit-content" }} className="top-performers-box">
      <div className="leaderboard-header">
        <h2>Fixture Schedule</h2>
      </div>
      <div className="leaderboard-list">
        {!fixtures || fixtures.length === 0 ? (
          <p style={{ color: "white", textAlign: "center", fontSize: "14px" }}>Generating Matchups..</p>
        ) : (
          fixtures.map((f, idx) => {
            const isHome = f.home_team_id === userTeamId;
            const opponent = isHome ? f.away_team : f.home_team;

            return (
              <div
                key={f.id}
                className={`leaderboard-row-fixture`}
                style={{
                  background: (() => {
                    switch (f.user_result) {
                      case "win":
                        return "linear-gradient(90deg, #1a232f 70%, rgb(22 199 132 / 30%) 100%)";
                      case "loss":
                        return "linear-gradient(90deg, #1a232f 70%, rgb(234 57 67 / 30%) 100%)";
                      default:
                        return "#1a232f";
                    }
                  })(),
                  border: (() => {
                    switch (f.user_result) {
                      case "win":
                        return "1px solid rgb(21 88 67)";
                      case "loss":
                        return "1px solid rgb(125 39 48)";
                      default:
                        return "1px solid rgba(156, 163, 175, 0)";
                    }
                  })(),
                  opacity: f.user_result === "pending" ? 1 : 0.4,
                }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: "10px",
                  }}>
                  <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
                      <CalendarFold size={16} color="#a9bdd6" />
                      <span style={{ color: "white", fontSize: "14px", fontWeight: 600 }}>Week {f.weekNumber}</span>
                    </div>
                  </div>

                  {/* Opponent */}
                  <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                    <img src={`/avatars/${opponent.profile_image}`} alt="" />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <h3 className="name" style={{ color: "white", margin: "0" }}>
                        {opponent.display_name}
                      </h3>
                    </div>
                  </div>
                </div>
                <p style={{ color: "#a9bdd6", fontSize: "12px", margin: 0 }}>
                  {formatDateUTC(f.week_start)} – {formatDateUTC(f.week_end)}
                </p>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default UpcomingFixtures;
